import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Admitting the Truth: It’s Hard for Me to Ask",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop telling myself “it’s not important.” I admit: it’s hard for me to express what I need."
    ],
      [
      "Daily intention: Today I stop telling myself “it’s not important.” I admit: it’s hard for me to express what I need."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This difficulty is trying to protect me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This difficulty is trying to protect me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is hard for me to ask for in this relationship?\n[Write here]",
      "What am I afraid will happen if I ask for it?\n[Write here]",
      "Where do I feel this fear in my body?\n[Write here]"
    ],
      [
      "What is hard for me to ask for in this relationship?\n[Write here]",
      "What am I afraid will happen if I ask for it?\n[Write here]",
      "Where do I feel this fear in my body?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Difficulty asking is a sign of sensitivity — not weakness."
    ],
      [
      "Closing",
      "Difficulty asking is a sign of sensitivity — not weakness."
    ]
    ),
    action: localizedGenderNode(
      "I notice one need of mine — without expressing it yet. Just noticing.",
      "I notice one need of mine — without expressing it yet. Just noticing."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What I Learned in the Past About Asking",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand where this comes from, without blaming."
    ],
      [
      "Daily intention: Today I understand where this comes from, without blaming."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “This was learned — it’s not who I am.”"
    ],
      [
      "I pause with myself.",
      "One breath. “This was learned — it’s not who I am.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happened in the past when I asked for something important?\n[Write here]",
      "What message did I take from that about needs and boundaries?\n[Write here]",
      "What gentle truth can exist today, even if the past was painful?\n[Write here]"
    ],
      [
      "What happened in the past when I asked for something important?\n[Write here]",
      "What message did I take from that about needs and boundaries?\n[Write here]",
      "What gentle truth can exist today, even if the past was painful?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The past explains me — it doesn’t have to control me."
    ],
      [
      "Closing",
      "The past explains me — it doesn’t have to control me."
    ]
    ),
    action: localizedGenderNode(
      "When the thought “better to stay quiet” arises — one breath + “this is old.”",
      "When the thought “better to stay quiet” arises — one breath + “this is old.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Fear of Being “Too Much”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I meet the fear of being a burden."
    ],
      [
      "Daily intention: Today I meet the fear of being a burden."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I feel like I’m “too much”?\n[Write here]",
      "What do I do with my needs in that moment?\n[Write here]",
      "If a friend felt this way — what would I tell them?\n[Write here]"
    ],
      [
      "When do I feel like I’m “too much”?\n[Write here]",
      "What do I do with my needs in that moment?\n[Write here]",
      "If a friend felt this way — what would I tell them?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A need doesn’t make me a burden. It makes me human."
    ],
      [
      "Closing",
      "A need doesn’t make me a burden. It makes me human."
    ]
    ),
    action: localizedGenderNode(
      "I say one sentence to myself that honors a need.",
      "I say one sentence to myself that honors a need."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Silence as a Habit",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see how silence protects — and how it hurts."
    ],
      [
      "Daily intention: Today I see how silence protects — and how it hurts."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I stay silent instead of speaking?\n[Write here]",
      "What do I gain from silence in the short term?\n[Write here]",
      "What is the long-term cost?\n[Write here]"
    ],
      [
      "When do I stay silent instead of speaking?\n[Write here]",
      "What do I gain from silence in the short term?\n[Write here]",
      "What is the long-term cost?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Silence protects for a moment — but charges a lasting price."
    ],
      [
      "Closing",
      "Silence protects for a moment — but charges a lasting price."
    ]
    ),
    action: localizedGenderNode(
      "I notice one moment of silence — without judging.",
      "I notice one moment of silence — without judging."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "A Boundary Is Not a Threat",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I learn that a boundary is not an attack."
    ],
      [
      "Daily intention: Today I learn that a boundary is not an attack."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “A boundary protects a relationship — it doesn’t destroy it.”"
    ],
      [
      "I pause with myself.",
      "One breath. “A boundary protects a relationship — it doesn’t destroy it.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which boundary is especially hard for me to set?\n[Write here]",
      "What am I afraid will happen if I set it?\n[Write here]",
      "What does a soft, non-aggressive boundary look like?\n[Write here]"
    ],
      [
      "Which boundary is especially hard for me to set?\n[Write here]",
      "What am I afraid will happen if I set it?\n[Write here]",
      "What does a soft, non-aggressive boundary look like?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary is information — not an ultimatum."
    ],
      [
      "Closing",
      "A boundary is information — not an ultimatum."
    ]
    ),
    action: localizedGenderNode(
      "I write one boundary for myself, on paper only.",
      "I write one boundary for myself, on paper only."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Separating a Request from a Demand",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I learn to ask without controlling."
    ],
      [
      "Daily intention: Today I learn to ask without controlling."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does a request sound when I’m under pressure?\n[Write here]",
      "How does a request sound when I’m calm?\n[Write here]",
      "Which version feels more connecting?\n[Write here]"
    ],
      [
      "How does a request sound when I’m under pressure?\n[Write here]",
      "How does a request sound when I’m calm?\n[Write here]",
      "Which version feels more connecting?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A request allows choice. A demand creates fear."
    ],
      [
      "Closing",
      "A request allows choice. A demand creates fear."
    ]
    ),
    action: localizedGenderNode(
      "I practice phrasing a calm request — just for myself.",
      "I practice phrasing a calm request — just for myself."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "What Happens in Me When I’m Not Heard",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I listen to the hurt without minimizing it."
    ],
      [
      "Daily intention: Today I listen to the hurt without minimizing it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I feel when I’m not listened to?\n[Write here]",
      "What do I do with that feeling?\n[Write here]",
      "What did I need to hear then?\n[Write here]"
    ],
      [
      "How do I feel when I’m not listened to?\n[Write here]",
      "What do I do with that feeling?\n[Write here]",
      "What did I need to hear then?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Hurt that isn’t spoken stays in the body."
    ],
      [
      "Closing",
      "Hurt that isn’t spoken stays in the body."
    ]
    ),
    action: localizedGenderNode(
      "Hand on chest + one breath when hurt arises.",
      "Hand on chest + one breath when hurt arises."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Fear of Rejection",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I meet the fear of being told “no.”"
    ],
      [
      "Daily intention: Today I meet the fear of being told “no.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Rejection is a possibility — not a verdict.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Rejection is a possibility — not a verdict.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I imagine will happen if they say “no”?\n[Write here]",
      "Has this happened before — and what actually happened?\n[Write here]",
      "What truth can I choose even if there is a “no”?\n[Write here]"
    ],
      [
      "What do I imagine will happen if they say “no”?\n[Write here]",
      "Has this happened before — and what actually happened?\n[Write here]",
      "What truth can I choose even if there is a “no”?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I remain worthy even when a request isn’t met."
    ],
      [
      "Closing",
      "I remain worthy even when a request isn’t met."
    ]
    ),
    action: localizedGenderNode(
      "I breathe for one minute with the possibility of “no.”",
      "I breathe for one minute with the possibility of “no.”"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Taking Responsibility for My Needs",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop expecting others to guess me."
    ],
      [
      "Daily intention: Today I stop expecting others to guess me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which need am I waiting for them to understand on their own?\n[Write here]",
      "How does it feel to wait without saying it?\n[Write here]",
      "What small step of responsibility could I take?\n[Write here]"
    ],
      [
      "Which need am I waiting for them to understand on their own?\n[Write here]",
      "How does it feel to wait without saying it?\n[Write here]",
      "What small step of responsibility could I take?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Expressing a need is responsibility — not weakness."
    ],
      [
      "Closing",
      "Expressing a need is responsibility — not weakness."
    ]
    ),
    action: localizedGenderNode(
      "I write one need in a simple sentence.",
      "I write one need in a simple sentence."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Speaking in First Person",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I speak without blame."
    ],
      [
      "Daily intention: Today I speak without blame."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does it sound when I blame?\n[Write here]",
      "How does the same thing sound in first person (“I feel / I need”)?\n[Write here]",
      "Which version feels safer to me?\n[Write here]"
    ],
      [
      "How does it sound when I blame?\n[Write here]",
      "How does the same thing sound in first person (“I feel / I need”)?\n[Write here]",
      "Which version feels safer to me?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "First-person language opens listening."
    ],
      [
      "Closing",
      "First-person language opens listening."
    ]
    ),
    action: localizedGenderNode(
      "I practice one first-person sentence.",
      "I practice one first-person sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Choosing the Right Moment",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I choose timing that respects me."
    ],
      [
      "Daily intention: Today I choose timing that respects me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I usually raise needs?\n[Write here]",
      "How does that affect the response?\n[Write here]",
      "When might be a slightly safer time?\n[Write here]"
    ],
      [
      "When do I usually raise needs?\n[Write here]",
      "How does that affect the response?\n[Write here]",
      "When might be a slightly safer time?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Timing is part of a boundary."
    ],
      [
      "Closing",
      "Timing is part of a boundary."
    ]
    ),
    action: localizedGenderNode(
      "I choose one future time for a conversation — without acting yet.",
      "I choose one future time for a conversation — without acting yet."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Tolerating Discomfort",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stay with discomfort for a moment — without retreating."
    ],
      [
      "Daily intention: Today I stay with discomfort for a moment — without retreating."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What feels most uncomfortable about expressing a need?\n[Write here]",
      "What happens if I stay with it for one minute?\n[Write here]",
      "What did I learn about my ability to tolerate it?\n[Write here]"
    ],
      [
      "What feels most uncomfortable about expressing a need?\n[Write here]",
      "What happens if I stay with it for one minute?\n[Write here]",
      "What did I learn about my ability to tolerate it?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Discomfort is temporary. Suppression is permanent."
    ],
      [
      "Closing",
      "Discomfort is temporary. Suppression is permanent."
    ]
    ),
    action: localizedGenderNode(
      "One minute of breathing with discomfort.",
      "One minute of breathing with discomfort."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Choosing Myself Without Losing the Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand that it can be both."
    ],
      [
      "Daily intention: Today I understand that it can be both."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does choosing myself mean within a relationship?\n[Write here]",
      "Which value am I no longer willing to give up?\n[Write here]",
      "Which one request represents that value?\n[Write here]"
    ],
      [
      "What does choosing myself mean within a relationship?\n[Write here]",
      "Which value am I no longer willing to give up?\n[Write here]",
      "Which one request represents that value?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Choosing myself can deepen connection."
    ],
      [
      "Closing",
      "Choosing myself can deepen connection."
    ]
    ),
    action: localizedGenderNode(
      "I write my value and keep it close.",
      "I write my value and keep it close."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure: A Voice That Has a Place",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I summarize without pressure to act immediately."
    ],
      [
      "Daily intention: Today I summarize without pressure to act immediately."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “My voice deserves space.”"
    ],
      [
      "I pause with myself.",
      "One breath. “My voice deserves space.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about myself on this journey?\n[Write here]",
      "What has become clearer, even if it hurts?\n[Write here]",
      "A return sentence for difficult days (short and clear):\n[Write here]"
    ],
      [
      "What did I learn about myself on this journey?\n[Write here]",
      "What has become clearer, even if it hurts?\n[Write here]",
      "A return sentence for difficult days (short and clear):\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I don’t have to shout to exist.",
      "I don’t have to stay silent to be loved.",
      "I can speak — slowly, respectfully, with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I don’t have to shout to exist.",
      "I don’t have to stay silent to be loved.",
      "I can speak — slowly, respectfully, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "I choose one small future step where I will give myself a voice.",
      "I choose one small future step where I will give myself a voice."
    ),
  },
].map(buildNormalizedDay);

export const difficultyExpressingNeedsAndBoundariesWithPartnerBlueprintEn = buildNormalizedPilotBlueprint({
  id: "difficulty_expressing_needs_and_boundaries_with_partner_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "difficulty_expressing_needs_and_boundaries_with_partner",
  category: "general",
  journeyName: {
    he: "קושי לבטא צרכים וגבולות מול בן/בת הזוג",
    en: "Difficulty Expressing Needs and Boundaries with a Partner",
    es: "Dificultad para expresar necesidades y límites en la pareja",
  },
  days,
});

export default difficultyExpressingNeedsAndBoundariesWithPartnerBlueprintEn;
